import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ObserverMapFacadeService } from '../../services/observer-map-facade.service';
import { SettingsMenuComponent } from '../settings-menu/settings-menu.component';

@Component({
  selector: 'app-map-toolbar',
  imports: [DatePipe, SettingsMenuComponent],
  templateUrl: './map-toolbar.component.html',
  styleUrl: './map-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapToolbarComponent {
  protected readonly facade = inject(ObserverMapFacadeService);
}
